export default {}

export const SET_ERROR = 'SET_ERROR'
export const SET_USER = 'SET_USER'
export const SET_AUTH = 'SET_AUTH'
export const PURGE_AUTH = 'PURGE_AUTH'
export const SET_JWT = 'SET_JWT'
export const SET_HAS_COPARENT = 'SET_HAS_COPARENT'
export const SET_HAS_CHILDREN = 'SET_HAS_CHILDREN'
export const SET_HAS_RECORD_KEEPING_COPARENTS = 'SET_HAS_RECORD_KEEPING_COPARENTS'
export const SET_COPARENTS = 'SET_COPARENTS'
export const SET_CASES = 'SET_CASES'
export const SET_FIRST_LOGIN = 'SET_FIRST_LOGIN'
export const SET_CAN_SEND_FUNDS = 'SET_CAN_SEND_FUNDS'
export const SET_IS_SUBSCRIBED = 'SET_IS_SUBSCRIBED'
export const SET_COPARENT_GUID = 'SET_COPARENT_GUID'
export const SET_CONTACTS_LIST = 'SET_CONTACTS_LIST'
export const SET_CONVERSATIONS_LIST = 'SET_CONVERSATIONS_LIST'
export const SET_PAYABLE_FROM = 'SET_PAYABLE_FROM'
export const SET_PAYMENT_PREFERENCE_COMPLETED = 'SET_PAYMENT_PREFERENCE_COMPLETED'
export const SET_PARENTING_SCHEDULE_PREFERENCE_COMPLETED = 'SET_PARENTING_SCHEDULE_PREFERENCE_COMPLETED'
export const SET_SUBSCRIBED_CONVERSATIONS_LIST = 'SET_SUBSCRIBED_CONVERSATIONS_LIST'
export const SET_CLICKED_ON_CONTACT = 'SET_CLICKED_ON_CONTACT'
export const SET_REGISTRATION_PROGRESS = 'SET_REGISTRATION_PROGRESS'
export const SET_SCROLL_DIRECTION = 'SET_SCROLL_DIRECTION'
export const SET_IS_SUBSCRIPTION_PAST_DUE = 'SET_IS_SUBSCRIPTION_PAST_DUE'
export const SET_IS_BANK_ACCOUNT_SKIPPED = 'SET_IS_BANK_ACCOUNT_SKIPPED'
